<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ $tc('areas.title', 0) }}</div>
      <v-spacer></v-spacer>
      <div class="d-flex justify-end">
        <v-dialog @keydown.esc="createDialog=false" v-model="createDialog" persistent max-width="300px">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="idRestaurant && areaPermissions['create-area']"
              v-on="on"
              fab
              x-small
              depressed
              color="primary"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ !form.data.name ? $t('areas.labels.createArea') : $t('areas.labels.editArea')}}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="areaForm" v-model="form.valid">
                <v-container grid-list-xl>
                  <v-layout wrap>
                    <v-flex xs12 md12>
                      <v-text-field
                        v-model="form.data.name"
                        :rules="form.rules.name"
                        :label="$t('areas.labels.areaName')"
                        maxlength="64"
                        required>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" small @click="onCloseCreateDialog">{{ $t('areas.buttons.actions.close') }}</v-btn>
              <v-btn color="primary" small :disabled="!form.valid" @click="submit">{{ $t('areas.buttons.actions.save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <v-flex xs12>
      <v-data-table
        v-if="idRestaurant"
        :loading-text="$t('areas.tables.loadingMessage')"
        :server-items-length="totalAreas"
        :loading="table.loading"
        :headers="table.headers"
        :items="areas"
        :items-per-page="table.limit"
        :page="table.page"
        :no-data-text="$t('areas.tables.noData')"
        :footer-props="{
          'items-per-page-options': [5, 10, 15]
        }"
        @update:page="updatePage"
        @update:options="nextPage"
        class="elevation-1 fixed-header">
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-end align-center">
            <v-tooltip v-if="areaPermissions['update-area']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="primary"
                  class="mr-2"
                  v-on="on"
                  @click="onOpenUpdateDialog(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('areas.tooltips.edit' )}}</span>
            </v-tooltip>
            <v-tooltip v-if="areaPermissions['delete-area']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="error"
                  v-on="on"
                  @click.prevent="onOpenVerifyCurrentOrders(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>{{$t('areas.tooltips.delete')}}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-flex
        v-else
        class="justify-center d-flex"
      >
        <div class="title">
          Selecciona un restaurant para ver sus áreas
        </div>
      </v-flex>
    </v-flex>

      <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="max-content">
        <v-card>
          <v-card-title>
            <span class="headline">{{$t('areas.labels.deleteArea', {type: this.form.data.name})}}</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" small @click="onCloseRemoveDialog">{{ $t('areas.buttons.actions.no') }}</v-btn>
            <v-btn color="success" small @click="remove">{{ $t('areas.buttons.actions.yes') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <ChangeOrdersArea
        :totalOrders="totalOrders"
        :sourceAreaId="sourceAreaId"
        @close="onOpenRemoveDialog(data)"
        ref="ChangeOrdersArea"
      />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { cloneDeep } from 'lodash'
import ChangeOrdersArea from '@/components/modals/ChangeOrdersArea'

export default {
  name: 'Areas',
  components: {
    ChangeOrdersArea
  },
  data () {
    return {
      deleteDialog: false,
      overlay: false,
      createDialog: false,
      removeDialog: false,
      loadingAreas: false,
      isEditing: false,
      table: {
        loading: true,
        data: [],
        total: 0,
        headers: [
          { text: this.$i18n.t('areas.tables.headers.areaName'), value: 'name' },
          { text: this.$i18n.t('areas.tables.headers.actions'), value: 'action', sortable: false }
        ],
        limit: 15,
        page: 1
      },
      form: {
        valid: false,
        rules: {
          name: [v => !!v || this.$t('validations.name')],
          restaurant: [v => !!v || this.$t('validations.restaurant')]
        },
        data: {
          name: null
        }
      },
      restaurants: {
        data: []
      },
      totalOrders: 0,
      sourceAreaId: '',
      data: {}
    }
  },
  async mounted () {
    try {
      const restaurants = await this.$api.get('/v1/restaurants')
      this.restaurants.data = restaurants.data
    } catch (error) {
      this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
    }
  },
  computed: {
    areas: function () {
      return this.$store.state.currentRestaurant.areas.data || []
    },
    totalAreas: function () {
      return this.areas.length
    },
    idRestaurant: function () {
      return this.$store.state.currentRestaurant.data._id || null
    },
    url: function () {
      return `/v1/restaurants/${this.idRestaurant}/areas`
    },
    areaPermissions () {
      return this.$store.state.login.permissions['settings'].components['areas'].actions
    }
  },
  methods: {
    resetForm () {
      this.form.data = {}
    },
    updatePage (page) {
      this.table.page = page
    },
    nextPage: async function (data) {
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1))
      })
    },
    async load (params = null) {
      try {
        await this.$store.dispatch('currentRestaurant/areas/get')
        this.table.loading = false
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
    },
    onCloseCreateDialog () {
      this.$refs.areaForm.reset()
      this.resetForm()
      this.createDialog = false
      this.isEditing = false
    },
    onOpenUpdateDialog (area) {
      this.form.data = cloneDeep(area)
      this.createDialog = true
      this.isEditing = true
    },
    onCloseUpdateDialog () {
      this.$refs.areaForm.reset()
      this.resetForm()
      this.createDialog = false
      this.isEditing = false
    },
    onOpenRemoveDialog: async function (area) {
      this.form.data = cloneDeep(area)
      this.removeDialog = true
    },
    onCloseRemoveDialog () {
      if (this.$refs && this.$refs.areaForm) this.$refs.areaForm.reset()
      this.resetForm()
      this.data = {}
      this.totalOrders = 0
      this.sourceAreaId = ''
      this.removeDialog = false
    },
    submit: async function () {
      if (this.$refs.areaForm.validate()) {
        this.overlay = true
        const request = this.form.data.id != null
          ? this.update()
          : this.create()
        try {
          await request
          this.onCloseCreateDialog()
          this.createDialog = false
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
        }
        this.overlay = false
      }
    },
    update: async function () {
      await this.$api.put(`${this.url}/${this.form.data.id}`, this.form.data)
    },
    remove: async function () {
      this.overlay = true
      try {
        await this.$api.del(`${this.url}/${this.form.data.id}`)
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
      this.onCloseRemoveDialog()
      this.overlay = false
    },
    create: async function () {
      await this.$api.post(`${this.url}`, this.form.data)
    },
    async onOpenVerifyCurrentOrders (item) {
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/restaurants/${this.idRestaurant}/areas/${item._id}/orders-by-area`)
        if (response.ordersPending) {
          this.$toasted.show(`No es posible eliminar el área: "${this.$store.state.area.name}" porque contiene ordenes de compra con el estatus de: "Recibida" o "Pendiente de pago", por favor primero termina el proceso`,
            {
              type: 'error',
              position: 'top-center',
              iconPack: 'mdi',
              icon: 'mdi-cancel',
              action: {
                text: 'Cerrar',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              }
            }
          )
        }
        if (response.ordersInTransit >= 1) {
          this.totalOrders = response.ordersInTransit
          this.sourceAreaId = item._id
          this.data = item
          this.$refs.ChangeOrdersArea.open()
        }
        if (response.noOrders) {
          await this.onOpenRemoveDialog(item)
        }
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
      this.overlay = false
    }
  }
}
</script>
